import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import SnackbarContent from '@mui/material/SnackbarContent';
const action = (_jsx(Button, Object.assign({ color: "secondary", size: "small" }, { children: "lorem ipsum dolorem" })));
export default function SnackbarExample() {
    return (_jsxs(Box, Object.assign({ sx: {
            maxWidth: 600,
            '& > * + *': {
                mt: 2,
            },
        } }, { children: [_jsx(SnackbarContent, { message: "I love snacks.", action: action }), _jsx(SnackbarContent, { message: 'I love candy. I love cookies. I love cupcakes. \
          I love cheesecake. I love chocolate.', action: _jsx(IconButton, Object.assign({ size: "small", "aria-label": "close", color: "inherit" }, { children: _jsx(CloseIcon, {}) })) }), _jsx(SnackbarContent, { message: "I love candy. I love cookies. I love cupcakes.", action: action }), _jsx(SnackbarContent, { message: 'I love candy. I love cookies. I love cupcakes. \
          I love cheesecake. I love chocolate.', action: action })] })));
}
